import ApiService from "./apiservice";

export const PatternService = {
    GetPatternList() {
        return ApiService.get("Pattern/GetPatternList");
    },
    GetPatternCode(params) {
        return ApiService.get("pattern/getpatterncode",params);
    },
    GetPatternPermission(params) {
        return ApiService.get("Pattern/GetPatternPermission",params);
    },
    findVacationPermission(params) {
        return ApiService.get("Pattern/findVacationPermission",params);
    },
    findMissionPermission(params) {
        return ApiService.get("Pattern/findMissionPermission",params);
    },
    findIOPermission(params) {
        return ApiService.get("Pattern/findIOPermission",params);
    },
    findExtraPermission(params) {
        return ApiService.get("Pattern/findExtraPermission",params);
    },
    findSpecificExtraworkPermission(params) {
        return ApiService.get("Pattern/FindSpecificExtraworkPermission",params);
    },
    AddPatternDetailvacationPermission(params) {
        return ApiService.post("Pattern/AddPatternDetailvacationPermission",null,params);
    },
    AddPatternDetailMissionPermission(params) {
        return ApiService.post("Pattern/AddPatternDetailMissionPermission",null,params);
    },
    AddPatternDetailIoPermission(params) {
        return ApiService.post("Pattern/AddPatternDetailIoPermission",null,params);
    },
    AddPatternDetailExtraWorkPermission(params) {
        return ApiService.post("Pattern/AddPatternDetailExtraWorkPermission",null,params);
    },
    AddWebSectionDetailSpecificExtraWorkPermission(params) {
        return ApiService.post("Pattern/AddWebSectionDetailSpecificExtraWorkPermission",null,params);
    },
    DeletePatternDetailPermission(params) {
        return ApiService.post("Pattern/DeletePatternDetailPermission",null,params);
    },
    AddPattern(params) {
        return ApiService.post("Pattern/AddPattern",null,params);
    },
    DeletePattern(params) {
        return ApiService.post("Pattern/DeletePattern",null,params);
    },
    DedicatePattern(params) {
        return ApiService.post("Pattern/DedicatePattern",null,params);
    },
    UpdatePatternName(data) {
        return ApiService.post("Pattern/UpdatePatternName",data);
    },
    UpdatePatternPermission(data) {
        return ApiService.post("Pattern/UpdatePatternPermission",data);
    },
};